import { Alert } from "@mui/material";
import { Redeem } from "@mui/icons-material";
import useIsDentist from "../utils/useIsDentist";

export default function LearnyspeedAlert() {
    const isDentist = useIsDentist();

    if (!isDentist) return <></>;

    return <Alert severity="info" icon={<Redeem />}>
        Pour deux inscriptions DPC, recevez un LearnySpeed offert !
    </Alert>;
}